<template>
  <div>
    <ls-table-layout>
      <div slot="search">
        <div class="table-page-search-wrapper">
          <a-form :form="queryParams" ref="topMenuForm" layout="inline" :labelCol="{ style: { width: '80px' } }">
            <a-row>
              <a-col :md="6" :sm="24">
                <a-form-item label="组织">
                  <global-select
                    :dropdown-match-select-width="false"
                    v-model="queryParams.orgNo"
                    selectType="selectDropDownRefresh"
                    v-decorator="[
                      'orgNo',
                      { rules: [{ required: true, message: '请选择公司主体' }] }
                    ]"
                    @change="handleVendorChange"
                    :setParams="{ organizationCode: organizationCodeOrigin }"
                    requestApi="/scp/scpProductionScheduling/listPcOrg"
                    :selectItem="{ value: 'realValue', label: 'label' }"
                  />
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="车间">
                  <a-select v-decorator="['workshopCodes']" v-model="queryParams.workshopCodes" option-filter-prop="children" option-label-prop="label" mode="multiple" :max-tag-text-length="2" :max-tag-count="1">
                    <a-select-option v-for="(item) in workshopCodeList" :key="item.workshopCode" :value="item.workshopCode" :label="item.workshopCode">
                      {{ item.workshopCode }}-{{ item.workshopDesc }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="9" :sm="24">
                <a-form-item label="生产时间">
                  <a-range-picker
                    v-decorator="['startDate1',{ rules: [{ required: true, message: '请选择开始时间' }] }]"
                    @change="handleStartDateChange"
                  />
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <span class="table-page-search-submitButtons">
                  <a-button @click="handleQuery" type="primary">查询</a-button>
                  <a-button @click="resetQuery" class="ml8">重置</a-button>
                </span>
              </a-col>
            </a-row>
          </a-form>
        </div>
      </div>

      <template v-slot:table>
        <div ref="topMenuBar" class="table-page-operator-wrapper btns">
          <a-button @click="goDetail(`/schedulingWorkbench/ProductionLineCapacity/${queryParams.vendorCode}&${queryParams.startDate1}&${queryParams.startDate2}`)" type="primary" >产线负荷查看</a-button>
          <a-button @click="goDetail(`/schedulingWorkbench/productionProcessesLoad/${queryParams.vendorCode}&${queryParams.startDate1}&${queryParams.startDate2}`)" type="primary" >工序负荷查看</a-button>
          <a-button @click="handleSubmitAdjustedRecalculation" type="primary">调整重算</a-button>
          <a-button @click="handleGoWorkOrderDesk" type="primary">工单发布</a-button>
          <a-button @click="handleGoProduction" type="primary">生产排产</a-button>
          <a-button @click="handleGoRevokeWorkOrders" type="primary">工单撤销</a-button>
          <div class="flex1"></div>
          <a-button @click="handleSave" type="primary">保存</a-button>
        </div>

        <div>
          <div class="full-width page-main-content">
            <!--左边菜单内容 -->
            <div class="page-content-left">
              <!--拖拉拽表格 -->
              <a-spin :spinning="isDragTableLoading">
                <ls-drag-table
                  class="mb10"
                  ref="lsDragTable"
                  :height="rightTopFormheight"
                  :tableObj="tableObj"
                  :leftMenuList="leftMenuList"
                  :vendor-name="currentVendorName"
                  @handle-drag-item-click="handleDragItemClick"
                  @update-cache-data-source="handleUpdateCacheDataSource"
                  :error-order-no="errorOrderNo"
                  :line-status-data="lineStatusData"
                ></ls-drag-table>
              </a-spin>
              <!--流程信息 -->
              <scheduling-info-table
                ref="refSchedulingInfoTable"
                :query-params="queryParams"
              >
              </scheduling-info-table>
            </div>
            <!--右边边菜单内容 -->
            <div class="page-content-right">
              <!--供应商信息 -->
              <scheduling-order-form class="mb10" @refresh-page="refreshPage" :scheduling-order-data="schedulingOrderData" ref="rightTopForm"></scheduling-order-form>
              <!--供应商列表信息 :cusHeight="RightTableHeight" -->
              <supplier-capacity-table-vue :capacity-table-data="capacityTableData" :cusHeight="RightTableHeight" class="flex1 h0"></supplier-capacity-table-vue>
            </div>
          </div>
        </div>
      </template>
    </ls-table-layout>
    <schedule-org-modal ref="scheduleOrgModalRef" />
    <a-modal
      v-model="isShowWorkOrderModal"
      title="工单发布"
      :destroyOnClose="true"
      @ok="handleWorkOrderModalOk"
      @cancel="handleWorkOrderModalCancel"
      :confirm-loading="isWorkOrderModalConfirmLoading"
    >
      <a-form layout="horizontal" :labelCol="{ span: 6 }" :wrapper-col="{ span: 18 }">
        <a-row>
          <a-form-item label="库存组织" :required="true">
            <global-select
              @change="handleFpOrgIdChange"
              :value.sync="workOrderModalData.fpOrgId"
              selectType="selectAssemble"
              :selectData="inventOrgData"
              :selectItem="{ value: 'realValue', label: 'label' }"
              :assembleLabel="true"
              :allowClear="false"
            />
          </a-form-item>
        </a-row>
        <a-row>
          <a-form-item label="车间">
            <a-select v-model="workOrderModalData.workshopCodes" option-filter-prop="children" option-label-prop="label" mode="multiple" :max-tag-text-length="2" :max-tag-count="1">
              <a-select-option v-for="(item) in workshopCodeList2" :key="item.workshopCode" :value="item.workshopCode" :label="item.workshopCode">
                {{ item.workshopCode }}-{{ item.workshopDesc }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-row>
        <a-row>
          <a-form-item label="公司主体">
            <global-select
              @successCallBack="finishProductSupplierGSCallBack"
              :value.sync="workOrderModalData.fpSupplierCode"
              selectType="selectSearch"
              :setParams="{orgNo: workOrderModalData.fpOrgId}"
              searchParam="supplierName"
              requestApi="/scp/scpProductionScheduling/findSupplier"
              :selectItem="{ value: 'lookUpCode', label: 'lookUpValue' }">
            </global-select>
          </a-form-item>
        </a-row>
        <a-row>
          <a-form-item label="排产时间" :required="true">
            <a-range-picker
              v-model="workOrderModalData.dateRange"
              :disabledDate="disabledDate"
              @calendarChange="handleWorkOrderModalCalendarChange"
              @openChange="handleWorkOrderModalOpenChange"
              @change="handleWorkOrderTimeRangeChange"
            />
          </a-form-item>
        </a-row>
        <a-row>
          <a-form-item label="计划来源" :required="true">
            <global-select
              selectType="selectMultipleFilter"
              :value.sync="workOrderModalData.planTypes"
              :selectData="planTypeList"
              :allowClear="false"
              :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
            />
          </a-form-item>
        </a-row>
      </a-form>
    </a-modal>
  </div>
</template>
<script>
import {
  getWorkSearch,
  submitAdjustedRecalculation,
  workOtherSupplierlistSearch,
  workLoadSearch,
  productionSchedulingPublish,
  revokeWorkOrders,
  getProdLineByOrg,
  getSystemInventOrgAll
} from '@/api/scp/productionScheduling/schedulingWorkbench.js'
import LsDragTable from './components/LsDragTable/LsDragTable.vue'
import SchedulingInfoTable from './components/SchedulingInfoTable/SchedulingInfoTable.vue'
import SchedulingOrderForm from './components/SchedulingOrder/SchedulingOrderForm.vue'
import SupplierCapacityTableVue from './components/SupplierCapacity/SupplierCapacityTable.vue'
import * as lodash from 'lodash'
import moment from 'moment'
import { mapState } from 'vuex'
import ScheduleOrgModal from '@/views/scp/productionScheduling/schedulingWorkbench/components/common/schedule-org-modal.vue'
import cacheRequest from '@/mixins/cacheRequest'
import { apiBomWorkshopFindList } from '@/api/mes/basedata/factoryAssembly'

export default {
  name: 'SchedulingWorkbench',
  components: {
    LsDragTable,
    SchedulingInfoTable,
    SchedulingOrderForm,
    SupplierCapacityTableVue,
    ScheduleOrgModal
  },
  mixins: [cacheRequest],
  data () {
    // 查询参数
    return {
      workshopCodeList: [], // 车间编码
      workshopCodeList2: [], // 车间编码
      planTypeList: [], // 计划来源
      schedulingInfoTableHeight: 0,
      RightTableHeight: 0,
      rightTopFormheight: 0,
      queryParams: this.$form.createForm(this),
      inventOrgData: [], // 组织数据
      leftMenuList: ['产线1', '产线2', '产线3'],
      // 拖拉拽表格数据
      tableObj: {
        dateList: [],
        tableData: [],
        loadList: []
      },
      // 拖拉拽表格最新版数据
      cacheDataSource: [],
      schedulingOrderData: {},
      // 当前数据的获取时的请求参数，用以保存
      currentParams: {
        orgNo: '', // 供应商ID,
        startDate1: '', // 生产时间开始
        startDate2: '' // 生产时间结束
      },
      currentVendorName: '',
      isDragTableLoading: false, // 拖拽表格是否处于loading状态
      capacityTableData: [],
      isShowWorkOrderModal: false,
      isWorkOrderModalConfirmLoading: false,
      workOrderModalData: {
        fpOrgId: '',
        workshopCodes: undefined, // 车间编码
        fpSupplierCode: '',
        startDate: '',
        endDate: '',
        dateRange: [],
        planTypes: ['IMPORT', 'MPS_PLAN']
      },
      errorOrderNo: '',
      lineStatusData: [],
      // 选择范围首日临时存储（用于禁用超出14天的日期）
      topCalendarFirstDate: null,
      workOrderCalendarFirstDate: null
    }
  },
  computed: {
    ...mapState({
      organizationCodeOrigin: (state) => state.user.organizationCode
    })
  },
  created () {
    this.workshopCodeList = []
    this.cacheLookupRequest('MES_CP_PLAN_TYPE', { lookupType: 'MES_CP_PLAN_TYPE', current: 1, pageSize: 999 }, 'planTypeList')
  },
  mounted () {
    this.updateBrowserHeight(); // 初始化时更新一次高度
    window.addEventListener("resize", this.handleDynamicHeight);
  },
  beforeDestroy () {
    window.removeEventListener("resize", this.handleDynamicHeight);
  },
  methods: {
    disabledDate(current) {
      if (!this.workOrderCalendarFirstDate && (!this.workOrderModalData.dateRange || this.workOrderModalData.dateRange?.length === 0)) {
        return false;
      }
      // 获取选择的开始日期（优先使用面板中选中的首日）
      const startDate = this.workOrderCalendarFirstDate || this.workOrderModalData.dateRange[0];

      if (!startDate) {
        return false;
      }

      // 计算14天前后的可选范围（含首尾，共14天）
      const minSelectableDate = startDate.clone().subtract(13, 'days');
      const maxSelectableDate = startDate.clone().add(13, 'days');

      const tooEarly = current && current < minSelectableDate;
      const tooLate = current && current > maxSelectableDate;

      return tooEarly || tooLate;
    },
    // 获取组织数据
    getInventOrg() {
      this.inventOrgData = []
      getSystemInventOrgAll({ pageNum: 1, pageSize: 999 }).then(res => {
        if(res?.code === 200 && res?.data?.length > 0 && this.organizationCodeOrigin) {
          this.inventOrgData = this.organizationCodeOrigin === 'A001' ? res.data : res.data.filter(item => item.realValue === this.organizationCodeOrigin)
        }
      })
    },
    handleQuery () {
      this.queryParams.validateFields((err, values) => {
        console.log(err, values)
        if (!err) {
          this.initData()
        }
      })
    },
    // 车间编码
    getBomWorkshopFindList (orgNo, field) {
      this[field] = []
      if (!orgNo) {
        return false
      }
      apiBomWorkshopFindList({ organizationCode: orgNo }).then(res => {
        this[field] = res
      })
    },
    resetQuery () {
      this.queryParams = this.$form.createForm(this)
      this.workshopCodeList = [] // 清空车间
    },
    handleStartDateChange (val) {
      this.queryParams.startDate1 = val[0].format('YYYY-MM-DD')
      this.queryParams.startDate2 = val[1].format('YYYY-MM-DD')
      // 选择完时间 清空限制
      this.selectPriceDate = ''
      this.createValue = val;
      this.topCalendarFirstDate = null;
    },
    handleVendorChange (val, list) {
      this.queryParams.orgNo = val
      this.queryParams.vendorCode = list?.find(item => item.realValue === val)?.supplierCode
      this.currentVendorName = list?.find(item => item.realValue === val)?.label
      // 重新获取车间编码
      this.queryParams.workshopCodes = undefined
      this.queryParams.setFieldsValue({ workshopCodes: undefined })
      this.getBomWorkshopFindList(this.queryParams.orgNo, 'workshopCodeList')
    },
    initData () {
      this.currentParams = {
        orgNo: this.queryParams.orgNo,
        workshopCodes: this.queryParams.workshopCodes,
        startDate1: this.queryParams.startDate1,
        startDate2: this.queryParams.startDate2
      }
      this.initWorkSearchTable()
      this.$refs.refSchedulingInfoTable.getData()
    },
    initWorkSearchTable () {
      this.errorOrderNo = ''
      this.tableObj = {
        dateList: [],
        tableData: []
      }
      this.isDragTableLoading = true
      Promise.all([getWorkSearch({
        orgNo: this.queryParams.orgNo,
        workshopCodes: this.queryParams.workshopCodes,
          startDate: this.queryParams.startDate1,
          endDate: this.queryParams.startDate2
        }), workLoadSearch(
          {
          workshopCodes: this.queryParams.workshopCodes,
          orgNo: this.queryParams.orgNo,
          startDate: this.queryParams.startDate1,
          endDate: this.queryParams.startDate2
        }
        ), getProdLineByOrg({
        orgNo: this.currentParams.orgNo,
        workshopCodes: this.queryParams.workshopCodes
        })
      ]).then((resultArray) => {
        const workSearchRes = resultArray[0]
        const workLoadSearchRes = resultArray[1]
        this.lineStatusData = resultArray[2]
        this.tableObj.loadList = workLoadSearchRes
        this.tableObj.dateList = Object.keys(workSearchRes).sort((a, b) => {
          // 使用moment()方法将日期字符串转换为moment对象
          const aMoment = moment(a, "YYYY-MM-DD");
          const bMoment = moment(b, "YYYY-MM-DD");

          // 使用isBefore()和isAfter()方法比较两个moment对象的先后顺序
          if (aMoment.isBefore(bMoment)) return -1;
          if (aMoment.isAfter(bMoment)) return 1;
          return 0;
        });

        this.tableObj.tableData = this.transformObjectToArray(workSearchRes)
        this.$nextTick(() => {
          this.$refs.lsDragTable.initTableObj()
          this.isDragTableLoading = false
        })
      }).catch(() => {
        this.isDragTableLoading = false
      })
    },
    goDetail (value) {
      this.$router.push({ path: value })
    },
    updateBrowserHeight () {
      //  <!-- 浏览器高度-->
      const browserHeight = window.innerHeight;
      //  <!-- Form的高度-->
      const topMenuFormHeight = this.$refs.topMenuForm.$el.clientHeight;
      // toolBar 的高度
      const topMenuBarHeight = this.$refs.topMenuBar.clientHeight;
      // 拖拽表格的高度
      const lsDragTableHeight = this.$refs.lsDragTable.$el.clientHeight;
      // 数据表格高度
      this.schedulingInfoTableHeight =
        browserHeight - topMenuFormHeight - topMenuBarHeight - lsDragTableHeight - 0;

       // 拖拽表格的高度
      this.rightTopFormheight = this.$refs.rightTopForm.$el.clientHeight;
      this.RightTableHeight =
        browserHeight - topMenuFormHeight - topMenuBarHeight - this.rightTopFormheight - 177;
    },
    handleDynamicHeight: lodash.throttle(function () {
      this.updateBrowserHeight()
      this.$refs.lsDragTable.resizeTableArea()
      // 在这里处理动态组件高度的变化
      // 可以使用 this.dynamicHeight 获取当前的高度值
      // 执行节流函数后，该函数将在一定时间间隔内最多被调用一次
    }, 100), // 设置节流函数的时间间隔为 200 毫秒
    transformObjectToArray (inputObject) {
      const resultArray = [];
      // 从输入对象中提取日期和产线
      const dateList = Object.keys(inputObject);

      // 获取所有产线并去重
      const lineList = Array.from(
        new Set(
          [].concat(
            ...dateList.map(date => Object.keys(inputObject[date]))
          )
        )
      ).sort();
      // 创建具有期望结构的对象数组
      lineList.forEach((line, index) => {
        const workshopCode = this.lineStatusData?.find(item => item.prodLineCode === line)?.workshopCode || '' // 车间
        const lineObject = {
          key: (index + 1).toString(),
          lineName: line,
          workshopCode: workshopCode
        };
        dateList.forEach(date => {
          // 将每个日期下的值添加到产线对象中，如果没有则为空数组
          lineObject[date] = (inputObject[date] && inputObject[date][line]) || [];
        });

        resultArray.push(lineObject);
      });

      return resultArray;
    },
    transformArrayToObject (resultArray) {
      const inputObject = {};
      resultArray.forEach((lineObject) => {
        const { key, lineName, vendorName, workshopCode, ...rest } = lineObject;
        const line = lineName;
        Object.keys(rest).forEach((date) => {
          // 创建日期的键值对，如果日期键不存在则创建
          inputObject[date] = inputObject[date] || {};
          // 将产线数据添加到日期键下
          inputObject[date][line] = rest[date];
        });
      });
      return inputObject;
    },
    handleDragItemClick (item) {
      this.schedulingOrderData = item
      // 获取库存组织相关数据
      this.$nextTick(() => {
        this.$refs.rightTopForm.findOrg()
      })
      this.capacityTableData = []
      workOtherSupplierlistSearch({
        itemId: item.itemId,
        pageNum: 1,
        pageSize: 999,
        vendorCode: this.queryParams.vendorCode,
        startDate: this.queryParams.startDate1,
        endDate: this.queryParams.startDate2
      }).then(res => {
        this.capacityTableData = res.rows
      })
    },
    handleSave () {
      this.$refs.rightTopForm.submit()
    },
    refreshPage () {
      this.schedulingOrderData = {}
      this.initData();
    },
    handleUpdateCacheDataSource (val) {
      this.cacheDataSource = val
    },
    // 调整重算
    handleSubmitAdjustedRecalculation () {
      this.queryParams.validateFields((err, values) => {
        if (!err) {
          if (!this.currentParams?.orgNo) {
            this.$message.warning('请先点击查询获取数据')
            return;
          }
          this.isDragTableLoading = true
          submitAdjustedRecalculation({
            orgNo: this.currentParams.orgNo,
            map: this.transformArrayToObject(this.cacheDataSource)
          }).then(() => {
            this.isDragTableLoading = false
            this.initWorkSearchTable()
          }).catch(err => {
            console.log(err)
            const errOrderNo = err.res.data
            this.errorOrderNo = errOrderNo
            this.isDragTableLoading = false
          })
        }
      })
    },
    // 生产排期
    handleGoProduction () {
      this.$refs.scheduleOrgModalRef.show(this.queryParams);
    },
    handleGoRevokeWorkOrders () {
      this.$confirm({
        title: '警告',
        content: '确定要撤销工单吗？',
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk: () => {
          revokeWorkOrders().then(res => {
          if (res.code === 200) {
            this.$message.success(res.msg)
          } else {
            this.$message.error(res.msg)
          }
        })
        }
      });
    },
    handleGoWorkOrderDesk () {
      // this.$router.push({ path: '/mes/work-order-manage/workOrderDesk' })
      this.workOrderModalData.fpOrgId = this.queryParams?.orgNo || ''
      // if (this.queryParams.orgNo) {
      //   this.workOrderModalData.fpOrgId = this.queryParams.orgNo
      // }
      this.workOrderModalData.workshopCodes = this.queryParams?.workshopCodes?.length > 0 ? this.queryParams.workshopCodes : undefined // 车间
      if (this.queryParams.startDate1 && this.queryParams.startDate2) {
        this.workOrderModalData.startDate = this.queryParams.startDate1
        this.workOrderModalData.endDate = this.queryParams.startDate2
        this.workOrderModalData.dateRange = [
          moment(this.queryParams.startDate1),
          moment(this.queryParams.startDate2)
        ]
      }
      this.getBomWorkshopFindList(this.workOrderModalData.fpOrgId, 'workshopCodeList2')
      this.getInventOrg()
      // 五金箱库存组织默认展示预测需求，用户导入，MPS计划单
      if(this.workOrderModalData.fpOrgId === 'B051') {
        this.$set(this.workOrderModalData, 'planTypes', ['FORECAST_DEMAND', 'IMPORT', 'MPS_PLAN'])
      }
      this.isShowWorkOrderModal = true
    },
    handleWorkOrderModalOk () {
      if (
        !this.workOrderModalData.fpOrgId ||
        !this.workOrderModalData.startDate ||
        !this.workOrderModalData.endDate ||
        !this.workOrderModalData?.planTypes ||
        this.workOrderModalData?.planTypes?.length < 1) {
        return this.$message.warning('请检查必填项')
      }
      this.isWorkOrderModalConfirmLoading = true
      productionSchedulingPublish({
        orgNo: this.workOrderModalData.fpOrgId,
        startDate: this.workOrderModalData.startDate,
        endDate: this.workOrderModalData.endDate,
        planTypes: this.workOrderModalData.planTypes,
        workshopCodes: this.workOrderModalData?.workshopCodes?.length > 0 ? this.workOrderModalData.workshopCodes : undefined
      }).then(res => {
        this.isWorkOrderModalConfirmLoading = false
        console.log(res)
        if (res.code === 200) {
          this.isShowWorkOrderModal = false
          this.$message.info(res.msg)
          this.workOrderModalData = {
            fpOrgId: '',
            fpSupplierCode: '',
            startDate: '',
            endDate: '',
            dateRange: [],
            planTypes: ['IMPORT', 'MPS_PLAN']
          }
        }
      }).catch(() => {
        this.isWorkOrderModalConfirmLoading = false
      })
    },
    finishProductSupplierGSCallBack (val) {
      if (this.workOrderModalData.fpOrgId && val && val[0]) {
        this.workOrderModalData.fpSupplierCode = val[0].lookUpCode
      }
    },
    handleWorkOrderTimeRangeChange (val) {
      this.workOrderModalData.startDate = val?.length === 2 ? val[0].format('YYYY-MM-DD') : null
      this.workOrderModalData.endDate = val?.length === 2 ? val[1].format('YYYY-MM-DD') : null
      this.workOrderCalendarFirstDate = null;
    },
    // 工单发布模态的面板日期变化
    handleWorkOrderModalCalendarChange(dates) {
      this.workOrderCalendarFirstDate = dates && dates[0] ? dates[0] : null;
    },
    // 工单发布模态的面板开合
    handleWorkOrderModalOpenChange(open) {
      if (!open) {
        this.workOrderCalendarFirstDate = null;
      }
    },
    handleFpOrgIdChange (val) {
      this.workOrderModalData.fpSupplierCode = ''
      this.workOrderModalData.workshopCodes = undefined
      this.getBomWorkshopFindList(this.workOrderModalData.fpOrgId, 'workshopCodeList2')
      // 五金箱库存组织默认展示预测需求，用户导入，MPS计划单
      if(val === 'B051') {
        this.$set(this.workOrderModalData, 'planTypes', ['FORECAST_DEMAND', 'IMPORT', 'MPS_PLAN'])
      } else {
        this.$set(this.workOrderModalData, 'planTypes', ['IMPORT', 'MPS_PLAN'])
      }
    },
    handleWorkOrderModalCancel () {
      this.workOrderModalData = {
        fpOrgId: '',
        workshopCodes: undefined, // 车间编码
        fpSupplierCode: '',
        startDate: '',
        endDate: '',
        dateRange: [],
        planTypes: ['IMPORT', 'MPS_PLAN']
      }
      this.$forceUpdate();
    }
  }
}
</script>
<style scoped>
.full-width {
  width: 100%;
}
.page-main-content {
  display: flex;
  height: 100%;
}
.page-content-left {
  /* // width: 850px; */
  flex:1;
  width: 0;
  background-color: white;
}
.page-content-line {
  width: 100%;
  height: 5px;
  background-color: rgb(240, 242, 245);
  margin: 5px 0;
}
.page-content-right {
  width: 280px;
  background-color: white;
  display: flex;
  flex-direction: column;
}
.table-page-operator-wrapper{
  margin-top: 5px;
  padding: 8px;
  background: #fff;
}
.content-area {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.btns {
  display: flex;
  background-color: white;
}
.flex1{
  flex: 1;
}
.h0 {
  height: 0;
}
.mb10{
  margin-bottom: 10px;
}
</style>
